import { SearchInput } from '../shared';
import { SortOrder, EmployeeSortType } from '../enums';

export class GetEmployeesInput extends SearchInput<EmployeeSortType> {
    public departmentIds: number[] | null;
    public isActive: boolean;

    constructor() {
        super(EmployeeSortType.LastName);
        this.sortOrder = SortOrder.Ascending;
        this.departmentIds = null;
        this.isActive = false
    }
}